import i18n from '@/libs/i18n'
import useBasicToast from '@/composable/useBasicToast'
import { classifyError } from './operationFeedback'

export default function useErrorManager() {
  const toast = useBasicToast()
  const errorManager = (err = 'errors.fetchError') => {
    toast({
      title: i18n.t(classifyError(err)),
      type: 'danger',
    })
  }

  return errorManager
}
